// get_leads returns a tab_status per financier on each lead:
//   { sent_to_financier | noa_approval | contract_signing: { status, is_active } }
// Kept as { [financierId]: { send, noa, contract } } keyed like every other
// bank-keyed store (String(financier_id)).
const API_TABS = { send: "sent_to_financier", noa: "noa_approval", contract: "contract_signing" };
const NEXT_STAGE = { send: "noa", noa: "contract" };

// The financier array's key isn't fixed across get_leads versions.
const financierRows = (row) =>
  [row?.financiers, row?.financier_details, row?.financier_list, row?.lead_financiers].find(Array.isArray) || [];

export const toFinancierTabStatus = (row) => {
  const out = {};
  financierRows(row).forEach((f) => {
    const id = f?.financier_id ?? f?.id;
    if (id == null || !f.tab_status) return;
    const entry = {};
    Object.entries(API_TABS).forEach(([stage, apiKey]) => {
      const t = f.tab_status[apiKey];
      if (t) entry[stage] = { status: t.status || "", isActive: !!t.is_active };
    });
    out[String(id)] = entry;
  });
  return out;
};

// "complete" (status approved) · "active" (is_active — its action is allowed)
// · "locked" (neither — the action can't be taken) · null when get_leads gave
// nothing for this bank/stage (e.g. a bank added on the Send page), in which
// case callers keep their own existing behaviour.
export const stageState = (tabStatus, key, stage) => {
  const t = tabStatus?.[key]?.[stage];
  if (!t) return null;
  if (t.status === "approved") return "complete";
  return t.isActive ? "active" : "locked";
};

// Local update after a successful save, so the page doesn't wait for a
// dashboard reload: the stage gets `status` and, once approved, the next
// stage becomes active.
export const withStageDone = (tabStatus, key, stage, status) => {
  const cur = { ...(tabStatus?.[key] || {}) };
  cur[stage] = { status, isActive: false };
  const next = NEXT_STAGE[stage];
  if (status === "approved" && next && cur[next]?.status !== "approved") cur[next] = { status: cur[next]?.status || "pending", isActive: true };
  return { ...(tabStatus || {}), [key]: cur };
};
